<template>
<div>
    <Chart type="bar" :data="chartData" :options="chartOptions" :height="height" :width="width" />
</div>
</template>

<script>
import Chart from 'primevue/chart';
import helpers from '@/helpers';
export default {
    props: {
        replayData: Object,
        height: Number,
        width: Number
    },
    components: {
        Chart
    },
    data() {
        return {


        }
    },
    computed: {
        chartData() {
            return{
                labels: this.replayData.statsDeals.map((item, index) => item.token),
                // labels: this.labels,
                datasets: [
                    {
                        label: 'Кумулятивный профит, %',
                        data: this.replayData.statsDeals.map((item) => this.round((item.cumulativeProfit / this.replayData.maxDepositUsage)*100, 2)),
                        // data: this.cumulativeProfit,
                        yAxisID: 'yLeft',
                        // backgroundColor: '#8fdeca',
                        backgroundColor: this.color,

                    },
                    {
                        label: 'Потенциальная просадка, %',
                        data: this.replayData.statsDeals.map((item) => this.round(item.potentialDrawdown*100, 2)),
                        // data: this.potentialDrawdown,
                        yAxisID: 'yRight',
                        // backgroundColor: '#E3C4FF',
                        backgroundColor: '#e4e2ff',
                    },
                ]
            }
        },
        chartOptions(){
            return {
                responsive: false,
                animation: false,
                // hoverMode: 'index',
                stacked: true,
                scales: {
                    yLeft: {
                        type: 'linear',
                        position: 'left',
                        grid: {
                            drawOnChartArea: false
                        }
                    },
                    yRight: {
                        type: 'linear',
                        // reverse: true,
                        position: 'right',
                        grid: {
                            drawOnChartArea: false
                        }
                    }
                },
                elements: {
                    bar: {
                        borderWidth: 0,
                    }
                },
            }
        },
        labels(){
            return this.replayData.statsDeals.map((item, index) => index+1);
        },
        cumulativeProfit(){
            return this.replayData.statsDeals.map((item) => item.cumulativeProfit);
        },
        potentialDrawdown(){
            return this.replayData.statsDeals.map((item) => item.potentialDrawdown);
        }
    },
    methods: {
        color(context){
            var index = context.dataIndex;
            var value = context.dataset.data[index];
            return value < 0 ? '#ff98a0' : '#85ea90';
        },
        ...helpers
    }
}

</script>
